import { useRouter } from 'next/router'

const en = {
    navShop: "Shop",
    navCustom: "Custom orders",
    customTeaser: "Pieces in the shop are finished artworks, sold exactly as shown. Want something made just for you? A custom order lets you pick the size (A4 or A3) and the finish.",
    startCustom: "Start a custom order",
    fromPrice: "From {price}",
    navAbout: "About",
    navContact: "Contact",
    cart: "Cart",
    openCart: "Open cart",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    language: "Language",
    currency: "Currency",
    addToCart: "Add to cart",
    inCart: "In your cart",
    sold: "Sold",
    soldOut: "Sold out",
    available: "Available",
    onlyLeft: "Only {n} left",
    inStock: "{n} available",
    viewAll: "View all work",
    freeShipping: "Free shipping",
    shippingSA: "Shipping in South Africa",
    shippingIntl: "International shipping",
    saOnly: "Ships within South Africa only",
    subtotal: "Subtotal",
    shipping: "Shipping",
    total: "Total",
    checkout: "Checkout",
    continueShopping: "Continue shopping",
    emptyCart: "Your cart is empty.",
    remove: "Remove",
    quantity: "Quantity",
    decrease: "Decrease quantity",
    increase: "Increase quantity",
    payInRand: "You pay in South African rand. Other currencies are shown at today's rate.",
    approx: "approx.",
    featured: "Featured piece",
    availableNow: "Available now",
    howTitle: "How buying works",
    step1Title: "Choose a piece",
    step1Text: "Pick an original or a print, or commission something new.",
    step2Title: "Pay securely",
    step2Text: "Checkout runs on Paystack. Your card details never touch this site.",
    step3Title: "Shipped to you",
    step3Text: "Packed by hand and sent with tracking, in South Africa or abroad.",
    startCustom: "Start a custom order",
    readMore: "Read more",
    shopTitle: "All work",
    shopIntro: "Originals, prints and everything that has already found a home.",
    filterAll: "All",
    filterAvailable: "Available",
    filterSold: "Sold",
    sortBy: "Sort by",
    sortNewest: "Newest",
    sortPriceLow: "Price, low to high",
    sortPriceHigh: "Price, high to low",
    emptyShop: "New work is on the way. Check back soon.",
    noMatches: "Nothing here right now.",
    medium: "Medium",
    size: "Size",
    year: "Year",
    edition: "Edition",
    askAbout: "Ask about this piece",
    backToShop: "Back to the shop",
    customTitle: "Custom order",
    chooseSize: "Choose a size",
    chooseFinish: "Choose a finish",
    finish_colour: "Colour",
    finish_inked: "Inked",
    finish_pencil: "Pencil",
    finish_full: "Full",
    finishDesc_colour: "Clean line work with flat colour.",
    finishDesc_inked: "Pencil drawing finished in black ink.",
    finishDesc_pencil: "A detailed graphite drawing.",
    finishDesc_full: "Inked, coloured and fully shaded.",
    size_A4: "210 x 297 mm",
    size_A3: "297 x 420 mm",
    describe: "What should I draw?",
    describeHint: "Describe the subject, style and any details. Up to 1500 characters.",
    unavailable: "Not available",
    yourDetails: "Your details",
    shippingDetails: "Shipping address",
    name: "Full name",
    email: "Email",
    phone: "Phone number",
    address1: "Street address",
    address2: "Apartment, unit or suite (optional)",
    city: "City",
    region: "Province or state",
    postalCode: "Postal code",
    country: "Country",
    payNow: "Pay {amount}",
    redirecting: "Taking you to payment...",
    checkoutNotReady: "Online payment opens soon. Please use the contact page to order in the meantime.",
    paymentMethod: "How would you like to pay?",
    payByCard: "Card",
    payByCardHint: "Visa, Mastercard and more, paid securely through Paystack.",
    payByEft: "EFT (bank transfer)",
    payByEftHint: "Pay straight into my bank account. You get the bank details on the next page and by email, and your order is held for 48 hours.",
    placeOrder: "Place order ({amount})",
    placingOrder: "Placing your order...",
    eftTitle: "Your order is reserved",
    eftText: "Please pay by EFT using the details below. Your order is held for you until the date shown and ships as soon as the payment is in. These details are also in your inbox.",
    bankName: "Bank",
    accountHolder: "Account holder",
    accountNumber: "Account number",
    branchCode: "Branch code",
    accountType: "Account type",
    amountToPay: "Amount",
    paymentReference: "Payment reference",
    payBefore: "Pay before",
    referenceHint: "Use exactly this reference so your payment can be matched to your order.",
    checkoutError: "Something went wrong. Please try again.",
    cannotShipAbroad: "{title} ships within South Africa only.",
    checkoutTitle: "Checkout",
    orderSummary: "Order summary",
    confirmedTitle: "Thank you for your order",
    confirmedText: "A confirmation is on its way to your inbox. You will hear from me when your art ships.",
    orderNumber: "Order number",
    pendingTitle: "We are confirming your payment",
    pendingText: "This can take a moment. If you were charged, your order is safe and a confirmation email will follow.",
    failedTitle: "Payment not completed",
    failedText: "Your payment did not go through, so nothing was charged. You can try again from your cart.",
    contactTitle: "Get in touch",
    contactIntro: "Questions about a piece, shipping or a commission? Send a message and you will get a reply by email.",
    message: "Message",
    piece: "About a piece (optional)",
    noPiece: "No specific piece",
    send: "Send message",
    sending: "Sending...",
    sent: "Thanks, your message is on its way. You will get a reply by email.",
    contactError: "Your message could not be sent. Please try again.",
    required: "Please fill in this field.",
    invalidEmail: "Please enter a valid email address.",
    footerShop: "Shop",
    footerInfo: "Information",
    shippingReturns: "Shipping and returns",
    privacy: "Privacy",
    rights: "All rights reserved.",
    notFoundTitle: "Page not found",
    notFoundText: "This page wandered off. Let's get you back to the art.",
    goHome: "Back to home",
    errorTitle: "Something went wrong",
    errorText: "Please try again in a moment."
}

export type DictionaryKey = keyof typeof en

type Dictionary = Record<DictionaryKey, string>

const es: Dictionary = {
    navShop: "Tienda",
    navCustom: "Encargos",
    customTeaser: "Las obras de la tienda están terminadas y se venden tal como se ven. ¿Quieres algo hecho solo para ti? Con un encargo eliges el tamaño (A4 o A3) y el acabado.",
    startCustom: "Hacer un encargo",
    fromPrice: "Desde {price}",
    navAbout: "Acerca de",
    navContact: "Contacto",
    cart: "Carrito",
    openCart: "Abrir carrito",
    openMenu: "Abrir menú",
    closeMenu: "Cerrar menú",
    language: "Idioma",
    currency: "Moneda",
    addToCart: "Añadir al carrito",
    inCart: "En tu carrito",
    sold: "Vendido",
    soldOut: "Agotado",
    available: "Disponible",
    onlyLeft: "Solo quedan {n}",
    inStock: "{n} disponibles",
    viewAll: "Ver toda la obra",
    freeShipping: "Envío gratis",
    shippingSA: "Envío en Sudáfrica",
    shippingIntl: "Envío internacional",
    saOnly: "Solo se envía dentro de Sudáfrica",
    subtotal: "Subtotal",
    shipping: "Envío",
    total: "Total",
    checkout: "Pagar",
    continueShopping: "Seguir comprando",
    emptyCart: "Tu carrito está vacío.",
    remove: "Quitar",
    quantity: "Cantidad",
    decrease: "Reducir cantidad",
    increase: "Aumentar cantidad",
    payInRand: "Pagas en rand sudafricano. Las demás monedas se muestran al cambio de hoy.",
    approx: "aprox.",
    featured: "Obra destacada",
    availableNow: "Disponible ahora",
    howTitle: "Cómo comprar",
    step1Title: "Elige una pieza",
    step1Text: "Escoge un original o una impresión, o encarga algo nuevo.",
    step2Title: "Paga de forma segura",
    step2Text: "El pago se hace con Paystack. Los datos de tu tarjeta nunca pasan por este sitio.",
    step3Title: "Te lo enviamos",
    step3Text: "Empaquetado a mano y enviado con seguimiento, en Sudáfrica o al extranjero.",
    startCustom: "Empezar un encargo",
    readMore: "Leer más",
    shopTitle: "Toda la obra",
    shopIntro: "Originales, impresiones y todo lo que ya ha encontrado hogar.",
    filterAll: "Todo",
    filterAvailable: "Disponible",
    filterSold: "Vendido",
    sortBy: "Ordenar por",
    sortNewest: "Más reciente",
    sortPriceLow: "Precio, de menor a mayor",
    sortPriceHigh: "Precio, de mayor a menor",
    emptyShop: "Hay obra nueva en camino. Vuelve pronto.",
    noMatches: "No hay nada aquí por ahora.",
    medium: "Técnica",
    size: "Tamaño",
    year: "Año",
    edition: "Edición",
    askAbout: "Preguntar por esta pieza",
    backToShop: "Volver a la tienda",
    customTitle: "Encargo personalizado",
    chooseSize: "Elige un tamaño",
    chooseFinish: "Elige un acabado",
    finish_colour: "Color",
    finish_inked: "Entintado",
    finish_pencil: "Lápiz",
    finish_full: "Completo",
    finishDesc_colour: "Línea limpia con color plano.",
    finishDesc_inked: "Dibujo a lápiz terminado en tinta negra.",
    finishDesc_pencil: "Un dibujo detallado en grafito.",
    finishDesc_full: "Entintado, coloreado y sombreado por completo.",
    size_A4: "210 x 297 mm",
    size_A3: "297 x 420 mm",
    describe: "¿Qué debo dibujar?",
    describeHint: "Describe el tema, el estilo y los detalles. Hasta 1500 caracteres.",
    unavailable: "No disponible",
    yourDetails: "Tus datos",
    shippingDetails: "Dirección de envío",
    name: "Nombre completo",
    email: "Correo electrónico",
    phone: "Teléfono",
    address1: "Dirección",
    address2: "Piso, unidad o apartamento (opcional)",
    city: "Ciudad",
    region: "Provincia o estado",
    postalCode: "Código postal",
    country: "País",
    payNow: "Pagar {amount}",
    redirecting: "Te llevamos al pago...",
    checkoutNotReady: "El pago en línea abrirá pronto. Mientras tanto, usa la página de contacto para hacer tu pedido.",
    paymentMethod: "¿Cómo quieres pagar?",
    payByCard: "Tarjeta",
    payByCardHint: "Visa, Mastercard y más, con pago seguro a través de Paystack.",
    payByEft: "EFT (transferencia bancaria)",
    payByEftHint: "Paga directamente a mi cuenta bancaria. Verás los datos bancarios en la siguiente página y por correo, y tu pedido queda reservado durante 48 horas.",
    placeOrder: "Hacer pedido ({amount})",
    placingOrder: "Haciendo tu pedido...",
    eftTitle: "Tu pedido está reservado",
    eftText: "Paga por transferencia con los datos de abajo. Tu pedido queda reservado hasta la fecha indicada y se envía en cuanto llegue el pago. Estos datos también están en tu correo.",
    bankName: "Banco",
    accountHolder: "Titular de la cuenta",
    accountNumber: "Número de cuenta",
    branchCode: "Código de sucursal",
    accountType: "Tipo de cuenta",
    amountToPay: "Importe",
    paymentReference: "Referencia de pago",
    payBefore: "Paga antes del",
    referenceHint: "Usa exactamente esta referencia para que tu pago se pueda asociar a tu pedido.",
    checkoutError: "Algo salió mal. Inténtalo de nuevo.",
    cannotShipAbroad: "{title} solo se envía dentro de Sudáfrica.",
    checkoutTitle: "Pago",
    orderSummary: "Resumen del pedido",
    confirmedTitle: "Gracias por tu pedido",
    confirmedText: "Te llegará una confirmación por correo. Te avisaré cuando tu arte se envíe.",
    orderNumber: "Número de pedido",
    pendingTitle: "Estamos confirmando tu pago",
    pendingText: "Puede tardar un momento. Si se te cobró, tu pedido está a salvo y recibirás un correo de confirmación.",
    failedTitle: "Pago no completado",
    failedText: "Tu pago no se realizó, así que no se cobró nada. Puedes intentarlo de nuevo desde tu carrito.",
    contactTitle: "Escríbeme",
    contactIntro: "¿Preguntas sobre una pieza, el envío o un encargo? Envía un mensaje y recibirás respuesta por correo.",
    message: "Mensaje",
    piece: "Sobre una pieza (opcional)",
    noPiece: "Ninguna pieza en concreto",
    send: "Enviar mensaje",
    sending: "Enviando...",
    sent: "Gracias, tu mensaje está en camino. Recibirás respuesta por correo.",
    contactError: "No se pudo enviar tu mensaje. Inténtalo de nuevo.",
    required: "Completa este campo.",
    invalidEmail: "Introduce un correo electrónico válido.",
    footerShop: "Tienda",
    footerInfo: "Información",
    shippingReturns: "Envíos y devoluciones",
    privacy: "Privacidad",
    rights: "Todos los derechos reservados.",
    notFoundTitle: "Página no encontrada",
    notFoundText: "Esta página se ha perdido. Volvamos al arte.",
    goHome: "Volver al inicio",
    errorTitle: "Algo salió mal",
    errorText: "Inténtalo de nuevo en un momento."
}

const fr: Dictionary = {
    navShop: "Boutique",
    navCustom: "Commandes sur mesure",
    customTeaser: "Les œuvres de la boutique sont terminées et vendues telles quelles. Envie d'une pièce faite pour vous ? Une commande sur mesure vous permet de choisir le format (A4 ou A3) et la finition.",
    startCustom: "Passer une commande sur mesure",
    fromPrice: "À partir de {price}",
    navAbout: "À propos",
    navContact: "Contact",
    cart: "Panier",
    openCart: "Ouvrir le panier",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    language: "Langue",
    currency: "Devise",
    addToCart: "Ajouter au panier",
    inCart: "Dans votre panier",
    sold: "Vendu",
    soldOut: "Épuisé",
    available: "Disponible",
    onlyLeft: "Plus que {n}",
    inStock: "{n} disponibles",
    viewAll: "Voir toutes les œuvres",
    freeShipping: "Livraison offerte",
    shippingSA: "Livraison en Afrique du Sud",
    shippingIntl: "Livraison internationale",
    saOnly: "Expédié uniquement en Afrique du Sud",
    subtotal: "Sous-total",
    shipping: "Livraison",
    total: "Total",
    checkout: "Commander",
    continueShopping: "Continuer mes achats",
    emptyCart: "Votre panier est vide.",
    remove: "Retirer",
    quantity: "Quantité",
    decrease: "Diminuer la quantité",
    increase: "Augmenter la quantité",
    payInRand: "Vous payez en rand sud-africain. Les autres devises sont affichées au taux du jour.",
    approx: "env.",
    featured: "Œuvre à la une",
    availableNow: "Disponible maintenant",
    howTitle: "Comment acheter",
    step1Title: "Choisissez une œuvre",
    step1Text: "Un original, un tirage, ou une création sur mesure.",
    step2Title: "Payez en toute sécurité",
    step2Text: "Le paiement passe par Paystack. Vos données de carte ne transitent jamais par ce site.",
    step3Title: "Livré chez vous",
    step3Text: "Emballé à la main et envoyé avec suivi, en Afrique du Sud ou à l'étranger.",
    startCustom: "Lancer une commande sur mesure",
    readMore: "En savoir plus",
    shopTitle: "Toutes les œuvres",
    shopIntro: "Originaux, tirages et tout ce qui a déjà trouvé sa place.",
    filterAll: "Tout",
    filterAvailable: "Disponible",
    filterSold: "Vendu",
    sortBy: "Trier par",
    sortNewest: "Plus récent",
    sortPriceLow: "Prix croissant",
    sortPriceHigh: "Prix décroissant",
    emptyShop: "De nouvelles œuvres arrivent. Revenez bientôt.",
    noMatches: "Rien ici pour le moment.",
    medium: "Technique",
    size: "Format",
    year: "Année",
    edition: "Édition",
    askAbout: "Poser une question sur cette œuvre",
    backToShop: "Retour à la boutique",
    customTitle: "Commande sur mesure",
    chooseSize: "Choisissez un format",
    chooseFinish: "Choisissez une finition",
    finish_colour: "Couleur",
    finish_inked: "Encré",
    finish_pencil: "Crayon",
    finish_full: "Complet",
    finishDesc_colour: "Trait net avec couleurs en aplat.",
    finishDesc_inked: "Dessin au crayon finalisé à l'encre noire.",
    finishDesc_pencil: "Un dessin détaillé au graphite.",
    finishDesc_full: "Encré, colorisé et entièrement ombré.",
    size_A4: "210 x 297 mm",
    size_A3: "297 x 420 mm",
    describe: "Que dois-je dessiner ?",
    describeHint: "Décrivez le sujet, le style et les détails. Jusqu'à 1500 caractères.",
    unavailable: "Indisponible",
    yourDetails: "Vos coordonnées",
    shippingDetails: "Adresse de livraison",
    name: "Nom complet",
    email: "E-mail",
    phone: "Téléphone",
    address1: "Adresse",
    address2: "Appartement, bâtiment (facultatif)",
    city: "Ville",
    region: "Province ou région",
    postalCode: "Code postal",
    country: "Pays",
    payNow: "Payer {amount}",
    redirecting: "Redirection vers le paiement...",
    checkoutNotReady: "Le paiement en ligne ouvre bientôt. En attendant, passez commande via la page de contact.",
    paymentMethod: "Comment souhaitez-vous payer ?",
    payByCard: "Carte",
    payByCardHint: "Visa, Mastercard et autres, paiement sécurisé via Paystack.",
    payByEft: "EFT (virement bancaire)",
    payByEftHint: "Payez directement sur mon compte bancaire. Vous recevez les coordonnées bancaires sur la page suivante et par e-mail, et votre commande est réservée pendant 48 heures.",
    placeOrder: "Passer la commande ({amount})",
    placingOrder: "Commande en cours...",
    eftTitle: "Votre commande est réservée",
    eftText: "Merci de payer par virement avec les coordonnées ci-dessous. Votre commande est réservée jusqu'à la date indiquée et part dès réception du paiement. Ces informations sont aussi dans votre boîte mail.",
    bankName: "Banque",
    accountHolder: "Titulaire du compte",
    accountNumber: "Numéro de compte",
    branchCode: "Code d'agence",
    accountType: "Type de compte",
    amountToPay: "Montant",
    paymentReference: "Référence de paiement",
    payBefore: "À payer avant le",
    referenceHint: "Utilisez exactement cette référence pour que votre paiement soit associé à votre commande.",
    checkoutError: "Une erreur est survenue. Veuillez réessayer.",
    cannotShipAbroad: "{title} est expédié uniquement en Afrique du Sud.",
    checkoutTitle: "Paiement",
    orderSummary: "Récapitulatif",
    confirmedTitle: "Merci pour votre commande",
    confirmedText: "Une confirmation arrive dans votre boîte mail. Vous serez prévenu dès l'expédition de votre œuvre.",
    orderNumber: "Numéro de commande",
    pendingTitle: "Nous confirmons votre paiement",
    pendingText: "Cela peut prendre un instant. Si vous avez été débité, votre commande est enregistrée et un e-mail de confirmation suivra.",
    failedTitle: "Paiement non abouti",
    failedText: "Votre paiement n'a pas abouti, rien n'a été débité. Vous pouvez réessayer depuis votre panier.",
    contactTitle: "Me contacter",
    contactIntro: "Une question sur une œuvre, la livraison ou une commande ? Envoyez un message, la réponse arrivera par e-mail.",
    message: "Message",
    piece: "À propos d'une œuvre (facultatif)",
    noPiece: "Aucune œuvre en particulier",
    send: "Envoyer",
    sending: "Envoi...",
    sent: "Merci, votre message est parti. Vous recevrez une réponse par e-mail.",
    contactError: "Votre message n'a pas pu être envoyé. Veuillez réessayer.",
    required: "Veuillez remplir ce champ.",
    invalidEmail: "Veuillez saisir une adresse e-mail valide.",
    footerShop: "Boutique",
    footerInfo: "Informations",
    shippingReturns: "Livraison et retours",
    privacy: "Confidentialité",
    rights: "Tous droits réservés.",
    notFoundTitle: "Page introuvable",
    notFoundText: "Cette page s'est égarée. Retournons aux œuvres.",
    goHome: "Retour à l'accueil",
    errorTitle: "Une erreur est survenue",
    errorText: "Veuillez réessayer dans un instant."
}

const de: Dictionary = {
    navShop: "Shop",
    navCustom: "Auftragsarbeiten",
    customTeaser: "Die Werke im Shop sind fertige Originale und werden genau so verkauft, wie sie zu sehen sind. Du möchtest etwas nur für dich? Bei einer Auftragsarbeit wählst du Format (A4 oder A3) und Ausführung.",
    startCustom: "Auftrag starten",
    fromPrice: "Ab {price}",
    navAbout: "Über mich",
    navContact: "Kontakt",
    cart: "Warenkorb",
    openCart: "Warenkorb öffnen",
    openMenu: "Menü öffnen",
    closeMenu: "Menü schließen",
    language: "Sprache",
    currency: "Währung",
    addToCart: "In den Warenkorb",
    inCart: "Im Warenkorb",
    sold: "Verkauft",
    soldOut: "Ausverkauft",
    available: "Verfügbar",
    onlyLeft: "Nur noch {n}",
    inStock: "{n} verfügbar",
    viewAll: "Alle Werke ansehen",
    freeShipping: "Kostenloser Versand",
    shippingSA: "Versand innerhalb Südafrikas",
    shippingIntl: "Internationaler Versand",
    saOnly: "Versand nur innerhalb Südafrikas",
    subtotal: "Zwischensumme",
    shipping: "Versand",
    total: "Gesamt",
    checkout: "Zur Kasse",
    continueShopping: "Weiter einkaufen",
    emptyCart: "Dein Warenkorb ist leer.",
    remove: "Entfernen",
    quantity: "Menge",
    decrease: "Menge verringern",
    increase: "Menge erhöhen",
    payInRand: "Du bezahlst in Südafrikanischen Rand. Andere Währungen werden zum Tageskurs angezeigt.",
    approx: "ca.",
    featured: "Ausgewähltes Werk",
    availableNow: "Jetzt verfügbar",
    howTitle: "So funktioniert der Kauf",
    step1Title: "Werk auswählen",
    step1Text: "Wähle ein Original oder einen Druck, oder gib etwas Neues in Auftrag.",
    step2Title: "Sicher bezahlen",
    step2Text: "Die Zahlung läuft über Paystack. Deine Kartendaten berühren diese Seite nie.",
    step3Title: "Zu dir verschickt",
    step3Text: "Von Hand verpackt und mit Sendungsverfolgung verschickt, in Südafrika oder ins Ausland.",
    startCustom: "Auftrag starten",
    readMore: "Mehr erfahren",
    shopTitle: "Alle Werke",
    shopIntro: "Originale, Drucke und alles, was schon ein Zuhause gefunden hat.",
    filterAll: "Alle",
    filterAvailable: "Verfügbar",
    filterSold: "Verkauft",
    sortBy: "Sortieren nach",
    sortNewest: "Neueste",
    sortPriceLow: "Preis aufsteigend",
    sortPriceHigh: "Preis absteigend",
    emptyShop: "Neue Werke sind unterwegs. Schau bald wieder vorbei.",
    noMatches: "Hier ist gerade nichts.",
    medium: "Technik",
    size: "Format",
    year: "Jahr",
    edition: "Auflage",
    askAbout: "Frage zu diesem Werk",
    backToShop: "Zurück zum Shop",
    customTitle: "Auftragsarbeit",
    chooseSize: "Format wählen",
    chooseFinish: "Ausführung wählen",
    finish_colour: "Farbe",
    finish_inked: "Getuscht",
    finish_pencil: "Bleistift",
    finish_full: "Komplett",
    finishDesc_colour: "Klare Linien mit flächiger Farbe.",
    finishDesc_inked: "Bleistiftzeichnung, mit schwarzer Tusche vollendet.",
    finishDesc_pencil: "Eine detaillierte Graphitzeichnung.",
    finishDesc_full: "Getuscht, koloriert und vollständig schattiert.",
    size_A4: "210 x 297 mm",
    size_A3: "297 x 420 mm",
    describe: "Was soll ich zeichnen?",
    describeHint: "Beschreibe Motiv, Stil und Details. Bis zu 1500 Zeichen.",
    unavailable: "Nicht verfügbar",
    yourDetails: "Deine Angaben",
    shippingDetails: "Lieferadresse",
    name: "Vollständiger Name",
    email: "E-Mail",
    phone: "Telefonnummer",
    address1: "Straße und Hausnummer",
    address2: "Wohnung oder Zusatz (optional)",
    city: "Stadt",
    region: "Provinz oder Bundesland",
    postalCode: "Postleitzahl",
    country: "Land",
    payNow: "{amount} bezahlen",
    redirecting: "Weiter zur Zahlung...",
    checkoutNotReady: "Die Online-Zahlung startet bald. Bestelle bis dahin bitte über die Kontaktseite.",
    paymentMethod: "Wie möchtest du bezahlen?",
    payByCard: "Karte",
    payByCardHint: "Visa, Mastercard und mehr, sicher bezahlt über Paystack.",
    payByEft: "EFT (Banküberweisung)",
    payByEftHint: "Zahle direkt auf mein Bankkonto. Die Bankdaten bekommst du auf der nächsten Seite und per E-Mail, und deine Bestellung wird 48 Stunden für dich reserviert.",
    placeOrder: "Bestellen ({amount})",
    placingOrder: "Bestellung wird aufgegeben...",
    eftTitle: "Deine Bestellung ist reserviert",
    eftText: "Bitte überweise den Betrag mit den Daten unten. Deine Bestellung ist bis zum angegebenen Datum reserviert und wird verschickt, sobald die Zahlung eingegangen ist. Die Daten findest du auch in deinem Postfach.",
    bankName: "Bank",
    accountHolder: "Kontoinhaber",
    accountNumber: "Kontonummer",
    branchCode: "Branch Code (Bankleitzahl)",
    accountType: "Kontotyp",
    amountToPay: "Betrag",
    paymentReference: "Verwendungszweck",
    payBefore: "Zahlen bis",
    referenceHint: "Gib genau diesen Verwendungszweck an, damit deine Zahlung deiner Bestellung zugeordnet werden kann.",
    checkoutError: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    cannotShipAbroad: "{title} wird nur innerhalb Südafrikas versendet.",
    checkoutTitle: "Kasse",
    orderSummary: "Bestellübersicht",
    confirmedTitle: "Danke für deine Bestellung",
    confirmedText: "Eine Bestätigung ist auf dem Weg in dein Postfach. Du hörst von mir, sobald deine Kunst verschickt wird.",
    orderNumber: "Bestellnummer",
    pendingTitle: "Wir bestätigen deine Zahlung",
    pendingText: "Das kann einen Moment dauern. Wenn dir etwas abgebucht wurde, ist deine Bestellung sicher und eine Bestätigung folgt per E-Mail.",
    failedTitle: "Zahlung nicht abgeschlossen",
    failedText: "Deine Zahlung ist nicht durchgegangen, es wurde nichts abgebucht. Du kannst es im Warenkorb erneut versuchen.",
    contactTitle: "Kontakt aufnehmen",
    contactIntro: "Fragen zu einem Werk, zum Versand oder zu einem Auftrag? Schreib eine Nachricht, die Antwort kommt per E-Mail.",
    message: "Nachricht",
    piece: "Zu einem Werk (optional)",
    noPiece: "Kein bestimmtes Werk",
    send: "Nachricht senden",
    sending: "Wird gesendet...",
    sent: "Danke, deine Nachricht ist unterwegs. Du bekommst eine Antwort per E-Mail.",
    contactError: "Deine Nachricht konnte nicht gesendet werden. Bitte versuche es erneut.",
    required: "Bitte fülle dieses Feld aus.",
    invalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
    footerShop: "Shop",
    footerInfo: "Informationen",
    shippingReturns: "Versand und Rückgabe",
    privacy: "Datenschutz",
    rights: "Alle Rechte vorbehalten.",
    notFoundTitle: "Seite nicht gefunden",
    notFoundText: "Diese Seite hat sich verirrt. Zurück zur Kunst.",
    goHome: "Zur Startseite",
    errorTitle: "Etwas ist schiefgelaufen",
    errorText: "Bitte versuche es gleich noch einmal."
}

const dictionaries: Record<string, Dictionary> = { en, es, fr, de }

export const translate = (locale: string | undefined, key: DictionaryKey, values?: Record<string, string | number>): string => {
    const dictionary = dictionaries[locale || 'en'] || en
    let text = dictionary[key] || en[key]

    if (values) {
        for (const [name, value] of Object.entries(values)) text = text.replace(`{${name}}`, String(value))
    }

    return text
}

export const useT = () => {
    const { locale } = useRouter()

    return (key: DictionaryKey, values?: Record<string, string | number>) => translate(locale, key, values)
}
